import { FC, useEffect, useState, useContext } from "react";
import ProcessExceptionsModal from "@app/exceptions/ProcessExceptionsModal";
import { ExceptionsFiltersContext } from "@app/exceptions/contexts/ExceptionsFiltersContext";
import ExceptionsService from "@app/exceptions/exceptionsService";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { QESButton } from "@app/shared/qes-standards/Button";

const UnprocessedExceptionsBanner: FC = () => {
  const exceptionsFilterContext = useContext(ExceptionsFiltersContext);
  const specialtyGroupExceptionsService = new ExceptionsService();
  const [isProcessConfirmationModalOpen, setIsProcessConfirmationModalOpen] = useState<boolean>(false);
  const [isBannerVisible, setIsBannerVisible] = useState<boolean>(false);

  useEffect(() => {
    if (exceptionsFilterContext.refreshUnprocessedExceptionsBanner)
    {
      specialtyGroupExceptionsService.hasUnprocessedSpecialtyGroupExceptions()
        .then(hasUnprocessedExceptions =>
        {
          setIsBannerVisible(hasUnprocessedExceptions);
        });
      exceptionsFilterContext.setRefreshUnprocessedExceptionsBanner(false);
    }
  }, [exceptionsFilterContext.refreshUnprocessedExceptionsBanner]);

  return (
    <>
      {isBannerVisible && (
        <QESAlert type="warning" persist={true} classNames="mt-3">
          Some specialty group exceptions are not yet processed. Exceptions in &quot;Read Only&quot; projects will not be processed. &nbsp;
          <QESButton
            qesType="secondary"
            qesTestId={`exception__processconfirmation`}
            onClick={() => setIsProcessConfirmationModalOpen(true)}
          >
            Process Now
          </QESButton>
        </QESAlert>
      )}
      <ProcessExceptionsModal
        isModalOpen={isProcessConfirmationModalOpen}
        setIsModalOpen={setIsProcessConfirmationModalOpen}
        onSuccess={()=> setIsBannerVisible(false)}
      />
    </>
  );
};

export default UnprocessedExceptionsBanner;